<script setup lang="ts">
const props = defineProps<{ isOpen?: boolean }>()
</script>

<template>
    <div class="relative w-6 flex-center flex-col cursor-pointer">
        <div 
            v-for="i in 3"
            :key="i"
            class="absolute w-full h-0.5 rounded-full bg-gray-600 transition-all duration-300" 
            :class="[
                i === 1 && (props.isOpen ? 'w-[200%] rotate-45' : '-translate-y-2'),
                i === 2 && props.isOpen ? 'hidden' : 'block',
                i === 3 && (props.isOpen ? 'w-[200%] -rotate-45' : 'translate-y-2'),
            ]"
        />
    </div>
</template>